export const LEGAL_FORMS = [
    'EINZELUNTERNEHMEN',
    'FREIBERUFLER',
    'EK',
    'GBR',
    'OHG',
    'KG',
    'GMBH',
    'GMBH_CO_KG',
    'UG',
    'AG',
    'SE',
    'EG',
    'LTD',
    'GESMBH',
    'AG_CH',
    'SONSTIGE',
];
/** Rechtsformen, die zwingend einen Handelsregistereintrag besitzen (§ 29 HGB). */
export const LEGAL_FORMS_WITH_REGISTER = [
    'EK',
    'OHG',
    'KG',
    'GMBH',
    'GMBH_CO_KG',
    'UG',
    'AG',
    'SE',
    'EG',
    'GESMBH',
    'AG_CH',
];
export function requiresCommercialRegister(legalForm, jurisdiction = 'DE', code) {
    if (jurisdiction !== 'DE')
        return false;
    if (code)
        return ['OL20', '40DB', '8Z6G', '2HBR', '63KS', '6QQB', 'SGST', 'AZFE'].includes(code);
    return LEGAL_FORMS_WITH_REGISTER.includes(legalForm);
}
export const COMPANY_PRIMARY_COLOR_DEFAULT = '#111827';
/** Auswahl kontraststarker Akzentfarben für Belegkopf und Tabellenlinien. */
export const COMPANY_COLOR_PRESETS = [
    '#111827',
    '#1D4ED8',
    '#0F766E',
    '#B45309',
    '#B91C1C',
    '#6D28D9',
];
export const COMPANY_LOGO_MIME_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'];
/** Obergrenze der Rohdatei; als Data-URL bleibt die Anfrage unter dem Body-Limit. */
export const COMPANY_LOGO_MAX_BYTES = 512_000;
export const INVOICE_DUE_DAYS_DEFAULT = 14;
export const QUOTE_VALIDITY_DAYS_DEFAULT = 30;
export const INVOICE_DUE_DAYS_MAX = 180;
export const QUOTE_VALIDITY_DAYS_MAX = 365;
const HEX_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/u;
export function isHexColor(value) {
    return HEX_COLOR_PATTERN.test(value);
}
/**
 * Relative Luminanz nach WCAG 2.1; entscheidet, ob Text auf der Akzentfarbe
 * hell oder dunkel gesetzt wird.
 */
export function readableTextColor(hexColor) {
    if (!isHexColor(hexColor)) {
        return '#111827';
    }
    const channels = [1, 3, 5].map((offset) => {
        const value = Number.parseInt(hexColor.slice(offset, offset + 2), 16) / 255;
        return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
    });
    const [red = 0, green = 0, blue = 0] = channels;
    const luminance = 0.2126 * red + 0.7152 * green + 0.0722 * blue;
    return luminance > 0.5 ? '#111827' : '#ffffff';
}
//# sourceMappingURL=company.js.map